<template>
  <vonap-window
    v-model="show"
    title="Add operations by date range"
    width="500px"
    :modal="true"
    @close="show = false"
  >
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-radio-group v-model="rangeOption" :mandatory="false">
                <v-radio label="By Month" value="month"></v-radio>
                <v-radio label="By Week" value="week"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs6>
              <vonap-form-label label="Start Date">
                <kendo-datepicker
                  style="width:120px"
                  :format="'yyyy-MM-dd'"
                  :required="true"
                  v-model="addRangeStartDate"
                ></kendo-datepicker>
              </vonap-form-label>
              <vonap-form-label label="End Date">
                <kendo-datepicker
                  style="width:120px"
                  :format="'yyyy-MM-dd'"
                  :required="true"
                  v-model="addRangeEndDate"
                ></kendo-datepicker>
              </vonap-form-label>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="blue primary" @click="addRangeDealsClick" title="Add Range"
          ><v-icon>check</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </vonap-window>
</template>

<script>
import VonapWindow from '@/components/VonapWindow'
import VonapFormLabel from '@/components/VonapFormLabel'
import dateRange, {dateRangeWeek} from '../../../services/dateRange'
export default {
  props: ['value', 'initialStartDate'],
  mounted() {
    this.initialize()
  },
  data() {
    return {
      rangeOption: 'month',
      addRangeStartDate: kendo.toString(kendo.parseDate(new Date()), 'yyyy-MM-dd'),
      addRangeEndDate: kendo.toString(kendo.parseDate(new Date()), 'yyyy-MM-dd'),
    }
  },
  watch: {
    value(value) {
      if (value === true) {
        this.initialize()
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    initialize() {
      this.addRangeStartDate = this.getRangeInitialStartDate()
      this.addRangeEndDate = this.getRangeInitialEndDate()
    },
    addRangeDealsClick: function() {
      const startDate = kendo.parseDate(this.addRangeStartDate, 'yyyy-MM-dd')
      const endDate = kendo.parseDate(this.addRangeEndDate, 'yyyy-MM-dd')
      const dates =
        this.rangeOption == 'month'
          ? dateRange(startDate, endDate)
          : dateRangeWeek(startDate, endDate)

      this.$emit('datesSelected', dates)
      this.show = false
    },
    getRangeInitialStartDate: function() {
      return kendo.toString(this.initialStartDate || new Date(), 'yyyy-MM-dd')
    },
    getRangeInitialEndDate: function() {
      let startDate = kendo.parseDate(this.getRangeInitialStartDate(), 'yyyy-MM-dd')
      const initialEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 7, 0)
      return kendo.toString(kendo.parseDate(initialEndDate), 'yyyy-MM-dd')
    },
  },
  components: {
    VonapWindow,
    VonapFormLabel,
  },
}
</script>
